import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import Button from "components/button";
import { recognitionFilters } from "variables/constants";
import { Form, Select, Input } from "antd";
import { Sparkles, Send } from "lucide-react";
import TextArea from "antd/es/input/TextArea";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";
import {
    getRecognitionWallDetails,
    doRecognitionWallCreate,
} from "../../../../../redux/recognitionwall/recognitionWallState";

const ShoutoutCard = ({
    onClose,
    onFilterChange,
    recordData,
    doCreate,
    doUpdate,
    getRecord,
    ...props
}) => {
    const [form] = Form.useForm();
    const { recordId } = props;
    const [message, setMessage] = useState("");
    const [selectedCategory, setSelectedCategory] = useState(null);
    
    useEffect(() => {
        getRecord(recordId);
    }, [getRecord, recordId]);

    const handleCategoryClick = (typeId) => {
        setSelectedCategory(typeId);
        form.setFieldsValue({ rcw_recognition_type_id: typeId });
        onFilterChange?.(typeId);
    };

    const onSubmit = (formData) => {
        try { 
            recordData.rcw_id > 0 ? doUpdate(formData): doCreate(formData);
            onClose();
        } catch (error) {
            console.error('Save failed:', error);
        }
    };

    return (
        <Card
            className="text-card-foreground flex flex-col gap-6 rounded-xl border-2 border-purple-300 dark:border-purple-700 bg-gradient-to-br from-purple-50 via-white to-emerald-50 dark:from-purple-950/20 dark:via-zinc-900 dark:to-emerald-950/20"
        >
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6">
                <div className="flex items-start gap-4">
                    <h4 className="flex items-center gap-2 text-lg">
                        <Sparkles className="w-5 h-5 text-purple-600" />
                        Send a Shoutout
                    </h4>
                </div>
            </div>
            <div className="px-6 pb-6 space-y-4">
                <div>
                    <Form
                        form={form}
                        layout="vertical" 
                        onFinish={onSubmit}
                    >
                        <FormItem 
                            name="rcw_id" 
                            hidden
                        >
                            <Input type="hidden" />

                        </FormItem>
                        <div className="grid grid-cols-3 xs:grid-cols-1 gap-4">
                            <div className="col-span-3">
                                <FormItem
                                    name="rcw_recognition_type_id"
                                    rules={[requiredField()]}
                                >
                                    <label className="text-sm font-medium mb-2 block">Select Category</label>
                                    <div className="flex flex-wrap gap-2">
                                        {recordData?.recognitionType?.map((type) => {
                                            const filterStyle = recognitionFilters.find(
                                                (f) => f.label.toLowerCase() === type.label.toLowerCase()
                                            );
                                            const typeId = type.value;
                                            const isActive = selectedCategory === typeId;

                                            return (
                                                <span
                                                    key={typeId}
                                                    onClick={() => handleCategoryClick(typeId)}
                                                    className={`
                                                        inline-flex h-8 items-center gap-1 px-3 py-1 !text-sm !font-medium border rounded-lg cursor-pointer transition-all
                                                        ${
                                                            isActive
                                                                ? `text-white bg-gradient-to-r ${filterStyle?.bg}`
                                                                : "text-slate-900 hover:bg-slate-100"
                                                        }
                                                    `}
                                                >
                                                    {filterStyle?.icon && <span className="mr-1">{filterStyle.icon}</span>}
                                                    {type.label}
                                                </span>
                                            );
                                        })}
                                    </div>
                                </FormItem>
                            </div>
                            <div>
                                <h1 className="text-sm font-medium mb-2 block">Select Recipient</h1>
                                <FormItem
                                    name="rcw_receiver_user_id"
                                    
                                >
                                    <Select 
                                        id="rcw_receiver_user_id"
                                        className="input-field"
                                        allowClear={true}
                                        options={recordData?.userList}
                                        placeholder="Select recipient"
                                    />
                                </FormItem>
                            </div>
                            <div className="col-span-3">
                                <h1 className="text-sm font-medium mb-2 block">Your Message</h1>
                                <FormItem
                                    name="rcw_message"
                                    rules={[requiredField()]}
                                >
                                    <TextArea
                                        className="input-field"
                                        maxLength={255}
                                        placeholder="Write something nice about your colleague... 💫"
                                        rows={3}
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                    />
                                </FormItem>
                            </div>
                        </div>
                    </Form>
                </div>
                <div className="flex gap-2 justify-end">
                    <Button
                        onClick={onClose}
                        className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all shrink-0 border bg-white text-slate-900 h-9 rounded-lg px-3 gap-2 hover:bg-slate-100 hover:text-slate-900 hover:shadow-none"
                    >
                        Cancel
                    </Button>
                    <Button
                         onClick={() => form.submit()}
                        className={`inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-all shrink-0 h-9 px-4 py-2 gap-2 hover:shadow-none ${
                            message.trim()
                                ? "bg-gradient-to-r from-purple-600 to-emerald-600 hover:from-purple-700 hover:to-emerald-700 text-white"
                                : "bg-gradient-to-r from-purple-600 to-emerald-600 text-white opacity-50"
                        }`}
                    >
                        <Send className="w-4 h-4" />
                        Send Shoutout
                    </Button>
                </div>
            </div>
        </Card>
    )
};
    
const mapStateToProps = (state) => ({
    recordData: state.recognitionWall.recognitionWallDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
    getRecord: (id) => dispatch(getRecognitionWallDetails(id)),
    doCreate: (data) => dispatch(doRecognitionWallCreate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShoutoutCard);